import { useMutation } from '@tanstack/react-query';

import { resendInvite } from '../../../common/api/clients/user.api';

export const useUserInvitationResend = () => {
    return useMutation({ mutationFn: resendInvite });
};
